import type { Component } from '@wix/thunderbolt-symbols'

// builder components carry their real type in builderType while componentType is the literal 'Builder'
// (see fixBuilderComponent in thunderbolt-becky-root). When the experiment is open, BI reports the real type.
export const getBiCompType = (comp: Component, useBuilderType: boolean): string =>
	(useBuilderType && comp.builderType) || comp.componentType
